export enum PromoType {
    PROMO_TIPO_ACUMULADO = 'ACUMULADO',
    PROMO_TIPO_RAPPEL = 'RAPPEL',
    PROMO_TIPO_PEDIDO_CERRADO = 'PEDIDO'
}